import { Injectable } from '@angular/core';
// import { Router } from '@angular/router';
import { AngularFireAuth } from "@angular/fire/compat/auth";

import { AngularFirestore } from '@angular/fire/compat/firestore';

// import * as firebase from 'firebase/app';
// import 'firebase/firestore'
// import { Timestamp } from 'firebase/firestore';
import { switchMap, map } from 'rxjs/operators';
import firebase from 'firebase/compat/app';

@Injectable({
  providedIn: 'root'
})
export class FirebaseFunctions {
  constructor( 
      private afAuth: AngularFireAuth, private db: AngularFirestore
      ) {}

testing(){
    console.log('testing');
}


  /**
   * Get all boards owned by current user
   */
  public getDataById(collection, theId) {
      return this.db
            .collection(collection)
            .doc(theId)
            .valueChanges();
  }

  public getDataById_IfLoggedIn(collection, theId) {
    return this.afAuth.authState.pipe(
      switchMap(user => {
        if (user) {
          return this.db
            .collection(collection)
            .doc(theId)
            .valueChanges();
        
        } else {
          return [];
        }
      }),
    );
  }

  public getDataByQuery_IfLoggedIn(collection, theId) {

    return this.afAuth.authState.pipe(
      switchMap(user => {
        if (user) {
          return this.db
            .collection(collection, ref =>
              ref.where('id', '==', theId)
            )
            .valueChanges();
        
        } else {
          return [];
        }
      }),
    );
  }

  public getAllData(collection) {

    return this.afAuth.authState.pipe(
      switchMap(user => {
        if (user) {
          return this.db.collection(collection).get();
        } else {
          return this.db.collection(collection).get();

        }
      }),
    );
  }

  public getAllData_IfLoggedIn(collection) {

    return this.afAuth.authState.pipe(
      switchMap(user => {
        if (user) {
          console.log(user)
          return this.db.collection(collection).get();
        } else {
          return [];
        }
      }),
    );
  }

// public getDataByIdNotSubscribe_IfLoggedIn(collection, theId) {
//     return this.afAuth.authState.pipe(
//       switchMap(user => {
//         if (user) {
//             return this.db
//                 .collection(collection, ref =>
//                 ref.where('id', '==', theId)
//                 ).get();
//         }
//         else{
//             return [];
//         }
//       }));
// }


public createOrUpdateDoc_IfLoggedIn(collection, theId, data) {
    const timestamp = firebase.firestore.FieldValue.serverTimestamp();
    return this.afAuth.authState.pipe(
        switchMap(user => {
                if (user) {
                   return this.db
                    .collection(collection)
                    .doc(theId)
                    .update({
                            data: data,
                            id: theId,
                            user: user.uid,
                            modified: timestamp
                            })
                        .then(() => {
                            console.log('success')
                            // update successful (document exists)
                        })
                        .catch((error) => {
                            console.log('Error updating user', error); // (document does not exists)
                            this.db
                                .collection(collection)
                                .doc(theId)
                                .set(   {
                                        data: data,
                                        id: theId,
                                        user: user.uid,
                                        modified: timestamp,
                                        created: timestamp,
                                        },
                                        {
                                            merge: true
                                        }
                                    );
                        });
                }
                else {
                    return [];
                }
        }));
}

}
